module.exports = __webpack_public_path__ + "img/DB4-1920_10.41501ba6.jpg";